<template>
    <div id="top">
        <div class="innerBox clearfix inner">
            <div class="wrap-box clearfix" @click="showBox">
                <img class="fl" src="@/assets/imgs/down.png" alt="">
                <div class="txt fl">
                    <p class="btn">下载邻友圈</p>
                    <p class="ltxt">立即下载&nbsp;&nbsp;&nbsp;&nbsp;二手换成钱</p>
                </div>
            </div>
            <div class="wrap-box"  @click="showBox">
                <img class="fl" src="@/assets/imgs/send.png" alt="">
                <div class="txt fl">
                    <p class="btn">发布二手</p>
                    <p class="ltxt">闲置换钱&nbsp;&nbsp;&nbsp;&nbsp;快速出手</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showBtn:true
        }
    },
    methods:{
        showBox() {
            this.$emit('func',this.showBtn)
        }
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
    #top{
        height: 150px;
        padding:22px 60px;
        background: url("../../assets/imgs/bg.png") no-repeat;
        .innerBox{
            height: 100%;
            border-radius: 3px;
            padding:20px 134px 23px;
            background: rgba(255,255,255,0.80);
            .wrap-box{
                cursor: pointer;
                width: 50%;
                float: left;
                &:first-child{
                    border-right:1px solid #95c847;
                }
                &:last-child{
                    padding-left:200px;
                }
                img{
                    width:64px;
                    margin: 0 28px 0 0;
                }
                .txt{
                    font-size:@ft22;
                    color:@fc32;
                    .btn{
                        margin-top:3px;
                        font-weight: bold;
                    }
                    .ltxt{
                        margin:6px 0 0 0;
                        font-size: @ft16;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/top.vue